import { render, staticRenderFns } from "./Alarms.vue?vue&type=template&id=58ee8033&scoped=true"
import script from "./Alarms.vue?vue&type=script&lang=js"
export * from "./Alarms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee8033",
  null
  
)

export default component.exports